import { t } from "@/i18n-js/instance";
import { calculateProgress, getUsageDetailsDescription } from "../billingUtils";
import { useBillingContext } from "../BillingContext";
import { UsageDetailsSection } from "./UsageDetailsSection";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.community";

export const CommunityUsageDetails = () => {
  const { currentPlan } = useBillingContext();

  if (!currentPlan?.usage_details) return null;

  const { spaces, admins, moderators, live_stream_hours } =
    currentPlan.usage_details;

  return (
    <UsageDetailsSection title={t(`${localeRoot}.title`)}>
      <UsageMetric
        title={t(`${localeRoot}.spaces.title`)}
        progress={calculateProgress(spaces.max, spaces.used)}
        description={getUsageDetailsDescription(spaces.used, spaces.max)}
      />
      <UsageMetric
        title={t(`${localeRoot}.admins.title`)}
        progress={calculateProgress(admins.max, admins.used)}
        description={getUsageDetailsDescription(admins.used, admins.max)}
      />
      <UsageMetric
        title={t(`${localeRoot}.moderators.title`)}
        progress={calculateProgress(moderators.max, moderators.used)}
        description={getUsageDetailsDescription(
          moderators.used,
          moderators.max,
        )}
      />
      <UsageMetric
        title={t(`${localeRoot}.live_stream_hours.title`)}
        progress={calculateProgress(
          live_stream_hours.max,
          live_stream_hours.used,
        )}
        description={getUsageDetailsDescription(
          live_stream_hours.used,
          live_stream_hours.max,
        )}
      />
    </UsageDetailsSection>
  );
};
